import DataTablesBase from '../datatables.js';

var Migrations = new DataTablesBase();

export default Migrations;